module.exports = __webpack_public_path__ + "img/app.c3a196ab.png";